<template>
  <div class="main-view">
    <div class="tag hide-scroll">
      <h4 class="tag__title">
        {{ i18nFieldValue(displayTag, 'name') }}
      </h4>
      <h5
        v-if="collectionName"
        class="tag__title"
      >
        {{ collectionName }}
      </h5>
      <div class="tag__photo">
        <button
          v-if="isDisplayTagArViewButtonVisible"
          ref="displayTagTooltipButton"
          class="arview-button"
          @mouseenter="showDisplayTagViewIn3DTooltip"
          @mouseleave="hideDisplayTagViewIn3DTooltip"
          @click="showArView(displayTag)"
        >
          <img :src="require('@/assets/images/armaker/arview-cube.png')">
          <div
            v-if="isDisplayTagViewIn3DTooltipVisible"
            class="tooltip"
          >
            {{ $t('viewIn3D') }}
          </div>
        </button>
        <img
          :src="displayTag.images[0]"
          @contextmenu.prevent="rightClickBlock"
          @click="$emit('preview', selectedIndex)"
        >
      </div>
      <pre class="tag__description">{{ i18nFieldValue(displayTag, 'description') }}</pre>
      <div class="tag__action">
        <template v-if="isJoorActionTag(displayTag) && isInJoorPlatform || !isJoorActionTag(displayTag)">
          <a
            v-show="displayTag.actionLink"
            class="cta-btn overflow-ellipsis"
            :title="getActionMutate(displayTag)"
            @click="handleActionClick(displayTag)"
          >
            {{ getActionMutate(displayTag) }}
          </a>
        </template>
        <template v-if="isJoorActionTag(displayTag) && isInJoorPlatform">
          <span class="overflow-ellipsis">{{ findWholesalePrice(displayTag) }}</span>
        </template>
        <template v-else>
          <template v-if="!isJoorActionTag(displayTag)">
            <span
              class="overflow-ellipsis"
              :title="i18nFieldValue(displayTag, 'price')"
            >{{ i18nFieldValue(displayTag, 'price') }}</span>
          </template>
        </template>
      </div>
    </div>
    <div class="gallery">
      <div
        v-for="(tag, index) in tags"
        :key="tag.objectId"
        class="gallery__item"
        @click="selectedIndex = index"
      >
        <img
          class="gallery__photo"
          :src="tag.images[0]"
          @contextmenu.prevent="rightClickBlock"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Message, Loading } from 'element-ui'
import { AR_VIEW_ENABLE_MARKERS } from '@/api/armaker'

export default {
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    i18nFieldValue: {
      type: Function,
      default: () => {}
    },
    getActionMutate: {
      type: Function,
      default: () => {}
    },
    isJoorActionTag: {
      type: Function,
      default: () => {}
    },
    availablePriceType: {
      type: Array,
      default: () => []
    },
    customSetting: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedIndex: 0,
      isDisplayTagViewIn3DTooltipVisible: false,
      showDisplayTagViewIn3DTooltipTimer: null,
      hideDisplayTagViewIn3DTooltipTimer: null
    }
  },
  computed: {
    ...mapGetters('joor', [
      'priceType',
      'products',
      'skus',
      'currentPriceType',
      'accessToken',
      'orders',
      'collections',
      'isInJoorPlatform'
    ]),
    displayTag () {
      return this.tags[this.selectedIndex]
    },
    collectionName () {
      if (this.isJoorActionTag(this.displayTag) && this.isInJoorPlatform) {
        const currentCollection = this.collections.find(collection => collection.id === this.displayTag.customAttribute.joorCollectionId)
        return currentCollection ? currentCollection.name : ''
      }
      return ''
    },
    arViewEnabled () {
      return this.customSetting.arView && AR_VIEW_ENABLE_MARKERS.includes('multitag')
    },
    isDisplayTagArViewButtonVisible () {
      const arViewAction = this.displayTag.arView ? this.displayTag.arView.action : null
      const arViewUrl = arViewAction ? arViewAction.url : ''
      return this.arViewEnabled && !!arViewUrl
    }
  },
  watch: {
    displayTag: {
      handler (val) {
        this.isDisplayTagViewIn3DTooltipVisible = false
        this.clearViewIn3DToolTipTimer()
        if (val && this.isDisplayTagArViewButtonVisible) {
          this.clearViewIn3DToolTipTimer()
          this.showDisplayTagViewIn3DTooltipTimer = setTimeout(() => {
            this.isDisplayTagViewIn3DTooltipVisible = true
            this.hideDisplayTagViewIn3DTooltipTimer = setTimeout(() => {
              this.isDisplayTagViewIn3DTooltipVisible = false
            }, 5000)
          }, 3000)
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'setPopupUrl',
      'setPopupSizeConfig',
      'showPopup'
    ]),
    ...mapActions('arview', [
      'showArViewPopup',
      'closeArViewPopup',
      'setArViewPopupAction',
      'setArViewPopupSize'
    ]),
    rightClickBlock (e) {
      e.preventDefault()
    },
    handleActionClick (tag) {
      if (this.isJoorActionTag(tag) && this.isInJoorPlatform) {
        this.addJoorItemProcess(tag)
        return
      }
      const url = this.i18nFieldValue(tag, 'actionLink')
      if (tag.actionType === 'iframe' || tag.actionType === 'largerIframe') {
        this.setPopupUrl(url)
        this.setPopupSizeConfig() // Set Defaults
        if (tag.actionType === 'largerIframe') {
          this.setPopupSizeConfig({
            widthPercent: 90,
            fullHeight: true
          })
        }
        this.showPopup()
      } else {
        window.open(url)
      }
    },
    async addJoorItemProcess (tag) {
      if (!this.collectionName || this.availablePriceType.length < 1) {
        Message.warning(this.$t('productUnavailable'))
        return
      }
      if (!this.currentPriceType.id) {
        Message.warning('Please select price type.')
        return
      }
      if (!this.findWholesalePrice(tag)) {
        Message.warning('The style is not support the selected price type.')
        return
      }
      const loadingInstance = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        await this.addToOrderProcess(tag)
        Message.success('Add style to cart success!')
        this.notifyAddItemToCartSuccess()
        loadingInstance.close()
      } catch (error) {
        console.error(error)
        Message.error(error)
        loadingInstance.close()
      }
    },
    findWholesalePrice (tag) {
      if (this.currentPriceType.id) {
        const currentSkuIds = this.products[tag.customAttribute.joorProductId]
        const targetSkuId = currentSkuIds ? currentSkuIds.find(skuId => this.currentPriceType.skus[skuId]) : ''
        if (targetSkuId) {
          return this.currentPriceType.skus[targetSkuId].wholesale_value
        }
      }
      return ''
    },
    notifyAddItemToCartSuccess () {
      window.parent.postMessage(
        JSON.stringify({
          error: false,
          success: true,
          message: 'Product Added'
        }),
        '*'
      )
    },
    showArView (tag) {
      const arViewAction = tag.arView.action
      const arViewSize = tag.arView.size
      const arViewActionTarget = arViewAction.target || 'iframe'
      if (arViewActionTarget === 'iframe') {
        this.setArViewPopupAction(arViewAction)
        this.setArViewPopupSize(arViewSize)
        this.showArViewPopup()
      }
    },
    showDisplayTagViewIn3DTooltip () {
      this.isDisplayTagViewIn3DTooltipVisible = true
      this.clearViewIn3DToolTipTimer()
    },
    hideDisplayTagViewIn3DTooltip () {
      this.isDisplayTagViewIn3DTooltipVisible = false
    },
    clearViewIn3DToolTipTimer () {
      clearTimeout(this.showDisplayTagViewIn3DTooltipTimer)
      clearTimeout(this.hideDisplayTagViewIn3DTooltipTimer)
      this.showDisplayTagViewIn3DTooltipTimer = null
      this.hideDisplayTagViewIn3DTooltipTimer = null
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/common/arview'

$font-size-s = 14px
$font-size-xs = 12px
.main-view {
  display: flex
  flex-direction: column
  justify-content: space-between
}
.tag {
  display: flex
  flex-direction: column
  overflow: auto
  height: 100%
  margin-bottom: 10px
  .tag__title {
    font-size: $font-size-s
    margin-bottom: 10px
  }
  .tag__photo {
    margin-bottom: 10px
    position: relative

    img {
      width: 100%
      object-fit: cover
    }
    .arview-button {
      right: 35px
      bottom: 15px

      img {
        width: 20px
      }
    }
  }
  .tag__description {
    overflow: auto
    margin-bottom: 10px
    height: 100%;
    min-height: 60px
    font-size: $font-size-xs
    white-space: pre-wrap
    line-height: 1.2
  }
  .tag__action {
    display: flex
    justify-content: space-between
    min-height: 20px
  }
}
.gallery {
  display: flex
  flex-direction: row
  overflow: auto
  height: 120px
  min-height: 120px
  .gallery__item {
    margin-right: 10px
  }
  .gallery__photo {
    height: 100px
    width: auto;
  }
}

.cta-btn {
  display: inline-block
  border-bottom: 1.5px solid #fff
  padding-bottom: 1px
  margin-bottom: 2px
  max-width: 130px
  color: #fff
  font-size: 14px
  font-weight: bold
  text-shadow: none
  cursor: pointer
}

.hide-scroll::-webkit-scrollbar {
  display: none;
}
.hide-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.overflow-ellipsis {
  max-width: 100%
}
</style>
